import React from 'react';
import { useAccess } from '@umijs/max';
import Exception403 from '@/pages/exception/403';

interface RoutePermissionGuardProps {
  permission: string;
  children: React.ReactNode;
}

const RoutePermissionGuard: React.FC<RoutePermissionGuardProps> = ({
  permission,
  children,
}) => {
  const access = useAccess();
  const hasPermission = access.hasPerm ? access.hasPerm(permission) : true;

  if (!hasPermission) {
    return <Exception403 />;
  }

  return <>{children}</>;
};

export default RoutePermissionGuard;
